import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'build',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description: 'Review pull requests that build against requirements',
    display: {
      isMain: true,
      position: 3,
    },
    name: 'Build',
    page: { alias: 'build' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
